import { Merchant } from '@nemuru-eng/js-api-client';

import { MerchantRegistrationDataEditDialog } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantRegistrationData/components/MerchantRegistrationDataEditDialog';
import { MerchantRegistrationDataForm } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantRegistrationData/components/MerchantRegistrationDataForm';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useDialog } from '@/components/shared/hooks/useDialog';

interface MerchantRegistrationDataProps {
  merchant: Merchant;
  editModeAllowed?: boolean;
  showInternalData: boolean;
}

export const MerchantRegistrationData = ({
  merchant,
  editModeAllowed,
  showInternalData,
}: MerchantRegistrationDataProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const toggleEditModeDialog = editModeAllowed && merchant ? toggleDialog : undefined;

  return (
    <SubSectionWrapper title={'REGISTRATION_DATA'} toggleEditModeDialog={toggleEditModeDialog}>
      {!merchant ? (
        <PendingDataWarning />
      ) : (
        <>
          <MerchantRegistrationDataForm merchant={merchant} showInternalData={showInternalData} />
          <MerchantRegistrationDataEditDialog
            opened={opened}
            setOpened={setOpened}
            toggleDialog={toggleDialog}
            merchant={merchant}
            showInternalData={showInternalData}
          />
        </>
      )}
    </SubSectionWrapper>
  );
};
